import React, { useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import mail from 'assets/images/Dashboard/mail-request.svg';
import call from 'assets/images/Dashboard/call-request.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from 'components/commom/Loader';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import { ClearTokenRedirectLogin } from 'utils/general';
import CommonToast from 'components/commom/CommonToast';
import { getImpressionsListCallApi } from 'store/getImpressions/action';

const ImpressionsClicksList = () => {
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const [list, setList] = useState([]);

  const loading = useSelector(
    (state) => state?.getImpressionsListReducer?.loading
  );

  useEffect(() => {
    getImpressionList();
  }, []);

  const getImpressionList = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setList(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getImpressionsListCallApi(external));
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0 mt-3 mb-5">
        <Col>
          {loading ? (
            <Loader />
          ) : list && list.length > 0 ? (
            <div className="pt-20">
              <Row className="listCustomHeader m-0 p-0 flex items-center">
                <Col lg={4} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Doctor & ID" />
                  </p>
                </Col>
                <Col lg={4} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Contact Info" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Impressions" />
                  </p>
                </Col>
                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    <FormattedMessage id="Clicks" />
                  </p>
                </Col>
              </Row>
              <Row className="bc-FFFFFF m-0 p-0">
                {list.map((item, index) => {
                  return (
                    <Row className="m-0 p-0 flex items-center listAppointment">
                      <Col lg={4} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center">
                          {item?.doctor_info?.full_name}
                        </div>
                        <div className="pt-04 fs-12 fc-202224 family_outfit_regular_400 lh-1512 flex items-center">
                          {item?.doctor_info?.patient_id}
                        </div>
                      </Col>
                      <Col lg={4} md={6} sm={12}>
                        <Stack
                          direction="horizontal"
                          gap={2}
                          className="items-center "
                        >
                          <Image src={mail} alt="icon" />
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176 break-all ...">
                            {item?.doctor_info?.email}
                          </div>
                        </Stack>
                        <Stack
                          direction="horizontal"
                          gap={2}
                          className="items-center pt-04"
                        >
                          <Image src={call} alt="icon" />
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                            {item?.doctor_info?.country_code}
                            {item?.doctor_info?.contact_number}
                          </div>
                        </Stack>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                          {item?.impressions}
                        </div>
                      </Col>
                      <Col lg={2} md={6} sm={12}>
                        <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                          {item?.clicks}
                        </div>
                      </Col>
                    </Row>
                  );
                })}
              </Row>
            </div>
          ) : (
            <div className="flex justify-center pt-120">
              <div>
                <Image src={EmptyScreen} alt="icon" />
                <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                  Nothing here yet
                </div>
              </div>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ImpressionsClicksList;
